export default __webpack_public_path__ + "static/media/team.7817224d.svg";